import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  timeout: 15000, // 15 secondes max par requête
  headers: {
    'Content-Type': 'application/json'
  }
});

// Intercepteur pour ajouter le token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Ajouter le domaine du tenant
    config.headers['X-Tenant-Domain'] = window.location.hostname;
    
    return config;
  },
  (error) => Promise.reject(error)
);

// Intercepteur pour gérer les erreurs
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Token expiré ou invalide
    if (error.response?.status === 401) {
      localStorage.removeItem('token');

      // Ne pas rediriger si on est sur une page publique (reset password, ticket public, enquête, etc.)
      const publicPaths = ['/login', '/forgot-password', '/reset-password', '/public/', '/survey/'];
      const isPublicPage = publicPaths.some(p => window.location.pathname.includes(p));

      if (!isPublicPage) {
        // Conserver la page actuelle pour y revenir après login
        const returnTo = encodeURIComponent(window.location.pathname + window.location.search);
        window.location.href = `/login?returnTo=${returnTo}`;
      }
    }

    return Promise.reject(error);
  }
);

export default api;
